import { useFormContext } from "react-hook-form";
import LojasAssociadasPromocao from "pages/retaguarda/promocoes/LojasAssociadasPromocao";
import { TabelaPrecoFormValues } from "pages/retaguarda/tabelaPrecoForm";

/**
 * Seletor de empresas da tabela de preços. Reaproveita o mesmo componente visual
 * da Promoção (LojasAssociadasPromocao). Autocontido: controla o campo
 * `empresasIds` do form. Nenhuma selecionada = todas as empresas.
 */
const EmpresasCard = () => {
  const { watch, setValue } = useFormContext<TabelaPrecoFormValues>();
  const selecionadas = watch("empresasIds") ?? [];

  const toggle = (id: string | number) => {
    const sid = String(id);
    const novo = selecionadas.includes(sid)
      ? selecionadas.filter((e) => e !== sid)
      : [...selecionadas, sid];
    setValue("empresasIds", novo, { shouldDirty: true });
  };

  return (
    <LojasAssociadasPromocao
      selectedLojas={selecionadas}
      onToggleLoja={toggle}
      titulo="Empresas"
      legenda={
        <>
          Selecione as empresas que usarão esta tabela. Se nenhuma for marcada, a
          tabela vale para <strong>todas as empresas</strong>.
        </>
      }
    />
  );
};

export default EmpresasCard;
